import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: "/em/entity-types", params });
